import React from 'react';
import Layout from '../components/Layout';
import AdminDashboard from './Dashboard';
import Sales from './Sales';
import PromoCode from './PromoCode';
import Settings from './Settings';
import Plan from './Plan';
import GiftIdeas from './GiftIdeas';

function AdminMain() {
  return (
    <Layout
      dashboard={<AdminDashboard />}
      sales={<Sales />}
      promoCode={<PromoCode />}
      giftIdeas={<GiftIdeas />}
      settings={<Settings />}
      plan={<Plan />}
    />
  );
}

export default AdminMain;
